export default __webpack_public_path__ + "static/media/icon-check-white.36044d1d.svg";